import { css } from '@emotion/core';
var _ref = {
  name: "19waxfi",
  styles: ".__flex{display:flex;justify-content:space-between;}.image-box{padding:0 0.5em;}"
};
export default (function (theme) {
  return _ref;
});